// extracted by mini-css-extract-plugin
module.exports = {"body":"InputAddShop_body__uTbLZ","paste":"InputAddShop_paste__14OWN"};